module.exports = {
  VueAppApiUrl: process.env.VUE_APP_API_URL? process.env.VUE_APP_API_URL : "http://localhost:40188",
  VueAppWebServiceUrl: process.env.VUE_APP_WEB_SERVICE_URL? process.env.VUE_APP_WEB_SERVICE_URL : "https://augmentive.health",
}
